import React from 'react';
import { YoutubeEmbed } from '@components/YoutubeEmbed';
import { ArticleBlockContentGridCol } from '../components/ArticleBlockContentGridCol/ArticleBlockContentGridCol';
import { BlockContentContext } from '../../BlockContent.utils';
import * as S from '../components/YoutubeSerializer/YoutubeSerializer.styles';
import { YoutubeEmbedSerializerProps } from '../components/YoutubeSerializer/YoutubeSerializer';

export const YoutubeSerializer = (context: BlockContentContext = BlockContentContext.Stripped) => {
  if (context === BlockContentContext.Article) {
    return ({ value }: YoutubeEmbedSerializerProps) => (
      <ArticleBlockContentGridCol>
        <YoutubeEmbed embed={value} />
      </ArticleBlockContentGridCol>
    );
  }
  return ({ value }: YoutubeEmbedSerializerProps) => (
    <S.Wrapper>
      <YoutubeEmbed embed={value} />
    </S.Wrapper>
  );
};
